import {type StateTree} from "pinia";

export interface UtilsStoreGetters extends StateTree {
}

export const getters =  {
};
